import { Link } from 'react-router-dom';
import { ANALYTICS_ENABLED, ConsentSnapshot, allowAnalytics, declineAnalytics } from '../../lib/analyticsConsent';
export const CONSENT_COPY = 'For parents: may we use Google Analytics cookies to measure visits to our parent and pricing pages? Analytics stay off unless you allow them. Change your choice anytime.';
const buttonClass = 'inline-flex min-h-[44px] flex-1 items-center justify-center whitespace-nowrap rounded-xl border-2 border-ink bg-white px-4 font-display text-[17px] text-ink transition-colors duration-150 ease-out hover:bg-cream-field focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink';
interface ConsentChoicesProps {
  snapshot: ConsentSnapshot;
  /** Show "Turn analytics off" when analytics are currently allowed. */
  allowWithdraw?: boolean;
  onLinkClick?: () => void;
}

/** Shared body for the consent card and the Cookie choices dialog. */
export function ConsentChoices({
  snapshot,
  allowWithdraw = false,
  onLinkClick
}: ConsentChoicesProps) {
  const granted = snapshot.choice === 'granted' && !snapshot.signalDenied;
  return <div className="space-y-4" data-id="element-101" data-mp="39lf8p21zy93n">
      {!ANALYTICS_ENABLED && <p className="rounded-xl bg-lavender-soft px-3 py-2 text-[15px] font-semibold text-ink" data-id="element-102" data-mp="35k3juyqy5rwi">
          Preview only: Google Analytics is switched off. Your choice is saved only in this browser.
        </p>}
      <p className="text-[16px] leading-relaxed text-ink" data-id="element-103" data-mp="15c26zmmeqgw">{CONSENT_COPY}</p>

      {snapshot.signalDenied && <p className="text-[15px] font-semibold text-ink" data-id="element-104" data-mp="3tbha8z5jfdeu">
          Your browser is sending a Global Privacy Control or Do Not Track signal, so analytics stay off.
        </p>}

      {!snapshot.storageAvailable && !snapshot.message && <p role="status" className="text-[15px] font-semibold text-coral-dark" data-id="element-105" data-mp="kue66p1zcc5e">
          This browser is blocking site storage, so analytics stay off.
        </p>}

      {snapshot.message && <p role="status" className="text-[15px] font-semibold text-coral-dark" data-id="element-106" data-mp="yzwos98l4nfx">
          {snapshot.message}
        </p>}

      {!snapshot.signalDenied && <div className="flex flex-col gap-3 sm:flex-row" data-id="element-107" data-mp="13y7ss3c783q8">
          {allowWithdraw && granted ? <button type="button" onClick={declineAnalytics} className={buttonClass} data-id="element-108" data-mp="q7clgvhcluor">
              Turn analytics off
            </button> : <>
              <button type="button" onClick={declineAnalytics} className={buttonClass} data-id="element-109" data-mp="g8nbrpzlvgjl">
                No thanks
              </button>
              <button type="button" onClick={allowAnalytics} className={buttonClass} data-id="element-110" data-mp="l65a6mfzyddc">
                Allow analytics
              </button>
            </>}
        </div>}

      <Link to="/privacy#website-analytics" onClick={onLinkClick} className="inline-flex min-h-[44px] items-center text-[15px] font-bold text-ink underline decoration-coral decoration-2 underline-offset-4" data-id="element-111" data-mp="balpkw6vv13w">
        Privacy details
      </Link>
    </div>;
}